module.exports = __webpack_public_path__ + "static/media/20190922_1326121.079459fb.jpg";